import { Link } from 'react-router-dom';
import CrudNombre from '../CrudNombre';
import { cn } from '../../ui';
import { getConvocatorias, createConvocatoria, updateConvocatoria, deleteConvocatoria } from '../api';

export default function SepeConvocatorias() {
  return (
    <CrudNombre
      titulo="Convocatorias"
      subtitulo="Cursos SEPE · convocatorias"
      placeholder="Buscar convocatoria…"
      art="convocatoria"
      api={{ list: getConvocatorias, create: createConvocatoria, update: updateConvocatoria, remove: deleteConvocatoria }}
      columnasExtra={[
        {
          key: 'cursos_count',
          header: 'Cursos',
          sortable: true,
          render: (item) => (
            <Link
              to={`/formacion/sepe/cursos?convocatoria=${item.id}`}
              className={cn(
                'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
                Number(item.cursos_count) > 0
                  ? 'bg-green-100 text-green-800 hover:bg-green-200'
                  : 'bg-gray-100 text-gray-500 hover:bg-gray-200',
              )}
            >
              {item.cursos_count ?? 0}
            </Link>
          ),
        },
      ]}
    />
  );
}
